import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  type: 'success' | 'error';
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;
  toasts = signal<Toast[]>([]);

  success(message: string) {
    this.add('success', message);
  }

  error(message: string) {
    this.add('error', message);
  }

  remove(id: number) {
    this.toasts.update((t) => t.filter((x) => x.id !== id));
  }

  private add(type: 'success' | 'error', message: string) {
    const id = ++this.counter;
    this.toasts.update((t) => [...t, { id, type, message }]);
    setTimeout(() => this.remove(id), 4500);
  }
}
